export enum UnionInfoStatus {
  REJECTED = -1,
  PENDING,
  VERIFIED,
}
